import { render, staticRenderFns } from "./AddStudentToGroupDialog.vue?vue&type=template&id=0b414bbd&scoped=true"
import script from "./AddStudentToGroupDialog.vue?vue&type=script&lang=js"
export * from "./AddStudentToGroupDialog.vue?vue&type=script&lang=js"
import style0 from "./AddStudentToGroupDialog.vue?vue&type=style&index=0&id=0b414bbd&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b414bbd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b414bbd')) {
      api.createRecord('0b414bbd', component.options)
    } else {
      api.reload('0b414bbd', component.options)
    }
    module.hot.accept("./AddStudentToGroupDialog.vue?vue&type=template&id=0b414bbd&scoped=true", function () {
      api.rerender('0b414bbd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/student/StudentGroupDialog/AddStudentToGroupDialog.vue"
export default component.exports